import { colors } from '@material-ui/core';

const white = '#FFFFFF';
const electricGreen = '#39FF14';
const electricGreenDark = '#00C853';
const electricGreenLight = '#B2FF59';

export default {
  primary: {
    contrastText: '#001a00',
    dark: electricGreenDark, // CHANGE FOR REBRANDING
    main: electricGreen, // CHANGE FOR REBRANDING
    light: electricGreenLight // CHANGE FOR REBRANDING
  },
  secondary: {
    contrastText: white,
    dark: electricGreenDark, // CHANGE FOR REBRANDING
    main: colors.grey.A700,
    light: colors.grey.A400
  },
  error: {
    contrastText: white,
    dark: colors.pink[900],
    main: colors.pink[600],
    light: colors.pink[400]
  },
  text: {
    primary: colors.grey[600],
    link: colors.grey[600]
  },
  link: colors.deepPurple[800],
  icon: colors.grey[600],
  background: {
    default: '#F4F6F8',
    paper: white
  },
  calendar: {
    eventBackground: electricGreenDark, // CHANGE FOR REBRANDING
    eventBackgroundBorder: electricGreen,
    todayDate: '#c8e6c9'
  },
  auth: {
    background: '#003d14' // CHANGE FOR REBRANDING
  },
  pills: {
    background: electricGreen,
    color: '#001a00'
  },
  anchorActive: 'white',
  anchor: colors.grey[400],
  divider: colors.grey[200]
};
